import { Icon } from 'antdV3';
import { COLOR_OPTIONS } from 'config/style';
import STTypo, { STTypoModels } from 'core/shared/typo';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import RegionalOverviewMycotoxinFieldContainer from './regional-overview-mycotoxin-field-container/regional-overview-mycotoxin-field-container';
import RegionalOverviewMycotoxinFieldInfoComponent from './regional-overview-mycotoxin-field-info-component';
import type { RegionalOverviewMycotoxinFieldsClusteredContainerProps } from './regional-overview-mycotoxin-fields-info-popup-bloc';
import { useMycotoxinFieldsInfoPopupBloc } from './regional-overview-mycotoxin-fields-info-popup-bloc';
import './regional-overview-mycotoxin-fields-info-popup-container.less';

const RegionalOverviewMycotoxinFieldsInfoContainer: React.FC<RegionalOverviewMycotoxinFieldsClusteredContainerProps> = props => {
  const { orderedData, hasClusterData, selectedField, handleSelectField, handleClosePopup, clusterCount, currentUnitSystem } =
    useMycotoxinFieldsInfoPopupBloc(props);
  const [t] = useTranslation();

  return (
    <div
      data-testid='regional-overview-mycotoxin-fields-clustered-container'
      className='regional-overview-mycotoxin-fields-clustered__container'>
      {hasClusterData && !selectedField && (
        <div
          data-testid='regional-overview-mycotoxin-fields-clustered-header'
          className='regional-overview-mycotoxin-fields-clustered__wrapper-header'>
          <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.NEUTRAL_80} fontWeight={500}>
            {t('pages.regional_overview.regional_mycotoxin.fields_clustered.title', { count: clusterCount })}
          </STTypo>
          <Icon
            onClick={handleClosePopup}
            type='close'
            style={{ fontSize: 18, color: COLOR_OPTIONS.DISABLED }}
            className='regional-overview-mycotoxin-fields-clustered__wrapper-header__close_button'
          />
        </div>
      )}

      <div
        data-testid='regional-overview-mycotoxin-fields-clustered-fields-list'
        className='regional-overview-mycotoxin-fields-clustered__wrapper-fields'>
        {hasClusterData &&
          !selectedField &&
          orderedData.map(field => {
            return (
              <RegionalOverviewMycotoxinFieldInfoComponent
                key={field.properties.id}
                fieldInfo={field}
                handleClickField={() => handleSelectField(field)}
              />
            );
          })}
      </div>

      {selectedField && (
        <RegionalOverviewMycotoxinFieldContainer
          currentUnitSystem={currentUnitSystem}
          fieldInfo={selectedField}
          handleClosePopup={handleClosePopup}
        />
      )}
    </div>
  );
};

export default RegionalOverviewMycotoxinFieldsInfoContainer;
